/**
 * design_handoff_accept_invitation §3 — invitation summary card used on the
 * Invitation and Confirm decline screens. Role and inviter rows only render
 * when the backend has the data (checkInvitation may omit them).
 *
 * @param {{name: string, icon?: string}} organization
 * @param {string=} inviterName
 * @param {string=} role
 * @param {string} invitedEmail
 */
import React from "react";
import classNames from "classnames";
import appConfig from "../../../../appConfig";
import { getUploadResourceUrl } from "../../../../helpers/url";
import { initialsFromName } from "../../templates/PageTemplate/useAccountShellData";
import { ROLE_LABELS } from "../OrganizationMembersPage/constants";
import styles from "./InvitationCard.module.scss";

const InvitationCard = ({ organization, inviterName, role, invitedEmail }) => {
  const icon = organization.icon
    ? getUploadResourceUrl(organization.icon)
    : null;

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <span className={classNames(styles.mark, { [styles.markImg]: icon })}>
          {icon ? (
            <img src={icon} alt="" />
          ) : (
            initialsFromName(organization.name)
          )}
        </span>
        <div>
          <div className={styles.name}>{organization.name}</div>
          <div className={styles.kind}>{appConfig.displayName} workspace</div>
        </div>
      </div>
      <dl className={styles.body}>
        {inviterName && (
          <>
            <dt>Invited by</dt>
            <dd>{inviterName}</dd>
          </>
        )}
        {role && (
          <>
            <dt>Your role</dt>
            <dd>{ROLE_LABELS[role] || role}</dd>
          </>
        )}
        <dt>Sent to</dt>
        <dd>{invitedEmail}</dd>
      </dl>
    </div>
  );
};

export default InvitationCard;
